module.exports = __webpack_public_path__ + "img/mamizou futatsuiwa_lw.cfac1144.png";